<div class="primary">
  <ng-content select="rt-toolbar-primary"></ng-content>
</div>
<div class="secondary">
  <ng-content select="rt-toolbar-secondary"></ng-content>
</div>
